export default {
      id: "Icon--audioMute-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--audioMute",
      toString: function () {
        return this.url;
      }
    }